import { AdminTabs } from '../../../constants/routing/admin/admin-tabs.constants';
import { Roles } from '../../../constants/security/roles.constants';

export const AdminTabsConfig = [
    {
        id: AdminTabs.users,
        title: 'Users',
        href: '/Admin/Users',
        requiredRoles: [Roles.Admin, Roles.Developer],
    },
    {
        id: AdminTabs.systems,
        title: 'Systems',
        href: '/Admin/Systems',
        requiredRoles: [Roles.Developer],
    },
];
